import { render } from "./HeaderWazzup.vue?vue&type=template&id=8e35057c&scoped=true"
import script from "./HeaderWazzup.vue?vue&type=script&lang=js"
export * from "./HeaderWazzup.vue?vue&type=script&lang=js"

import "./HeaderWazzup.vue?vue&type=style&index=0&id=8e35057c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e35057c"]])

export default __exports__